<template>
  <v-container class="pt-12">
    <v-row justify="space-around">
      <v-col cols="12" lg="8" >
        <v-card class="mb-0 pb-0">
          <v-alert
            class="mb-0"
            color="#2A3B4D"
            dark
            icon="mdi-firework"
          >
            <h1>Bienvenidos a <b>support-smipack.com</b></h1>
            Un portal donde podras navegar con mucha facilidad para encontrar manuales de uso, 
            diagrama de partes y hasta las especificaciones de tus maquinas de Smipack.<br/>

            Solo necesitas <b>REGISTRARTE</b> y así podras solucionar todas tus dudas sobre el mantenimiento de dichas maquinas.<br/>
             
            Puedes consultar en "imágenes de muestra" debajo del recuadro de registro para asi visualizar una demostracion de los manuales y 
            diagramas que encontraras dentro del portal.
          </v-alert>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="space-around" align="center" >
    
      <v-snackbar v-model="snackbar" :timeout="8000" top color="orange" dark  > {{text}}
        <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
      </v-snackbar>

      <v-col cols="12"  sm="6" md="5" lg="4" xl="3" >
        <v-card class="elevation-10 pa-1" id="contenedor" >
          <v-card-text class="mt-2">

            <v-img
              :src="`https://support-smipack.com/fotos/techsupport.jpg`"
              :lazy-src="`https://picsum.photos/10/6?image=${1 * 5 + 10}`"
              aspect-ratio="1.5"
              class="grey lighten-2 pa-2 mb-5"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              width="100%" 
              transparent
              id="logo"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
           

            <v-form>
              <v-text-field
                autofocus
                v-model="email" 
                prepend-icon="email" 
                label="Correo" 
                required
                type="text"
                outlined
                dense 
                color="white"
                clearable
                dark
                >
              </v-text-field>

              <v-text-field
                v-model="password"
                prepend-icon="lock"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                label="contraseña"
                hint="At least 8 characters"
                counter
                @click:append="show1 = !show1"
                outlined
                dense
                hide-details
                dark
                color="white"
                clearable
              ></v-text-field>

              <v-col xs12>
                <v-card v-if="error" color="red lighten-1" class=" px-2 py-2">
                  <div class="white--text">
                    {{ error }}
                  </div>
                </v-card>
              </v-col>

            </v-form>
          </v-card-text>
            
              <!-- BOTONES -->
          <v-card-actions class="mx-3">
            <v-spacer></v-spacer>
            <v-btn  color="white" outlined small dark :to="{name:'registro'}" >Registrarse</v-btn>
            <v-btn  color="primary" small dark @click="ingresar" class="elevation-5">Iniciar Sesión</v-btn>
          </v-card-actions>
          
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="terciario" text dark x-small :to="{name: 'olvidacontra'}">Olvide mi contraseña.</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="space-around">
      <v-col cols="12"  sm="6" md="5" lg="4" xl="3" >
        <v-card class="elevation-0  transparent" align="right" :to="{name:'about'}">
          <h3>Imágenes de muestra <v-icon color="primary">mdi-chevron-right</v-icon></h3>
        </v-card>
      </v-col>
    </v-row>



  </v-container>
</template>

<script>
import router from '@/router'
import {mapActions , mapGetters} from 'vuex'
  export default {
    data(){
      return{
        dialog: true,
        password: '',
        email:'',

        snackbar: false,
        y: 'top',
        x: null,
        mode: '',
        timeout: 8000,
        text: '',

        show1: false,
        error: '',


        rules: {
          required: value => !!value || 'Requerido.',
          min: v => v.length >= 8 || 'Minimo 8 caracteres',
          emailMatch: () => ('El correo y/o la contraseña no son correctos')
        },

        NombreAsig: '',
        Nomuser: '',
      }
    },

    computed:{
      ...mapGetters('Login',['getdatosUsuario']),
    },

    
    methods:{
      ...mapActions('Login',['validarUser']),
      ...mapActions('Login',['GetInfoUser' ,]),


      ingresar (){
        var md5     = require('md5')
        // var payload = { "Username": this.email, "Password": md5(this.password)}
        var usuario = { "email" : this.email, "password": md5(this.password)}
        // Traemos la información del usuario
        this.GetInfoUser(usuario).then(response => {
          if(response == false){
            this.text  = "Verifica que tus datos esten correctos"
            this.snackbar = true 
            return
          }else if(response == true){
            this.$router.push({ name: 'listseries' })  
          }else{
            this.text  = response; this.snackbar = true 
          }
        }).catch(error =>{
          console.log(error)
        })
      }
    }
  };


</script>

<style scoped>
  
  #logo{
   border-radius:25px;
  }

  #contenedor{
    background: #373B44;  
    background: -webkit-linear-gradient(to right, #4286f4, #373B44);  
    background: linear-gradient(to right, #4286f4, #373B44);
    border-radius: 25px;
  }

  .v-main__wrap{
    background: #373B44 !important; 
  }
 
</style>



  